module.exports = __webpack_public_path__ + "static/footer-humm-b4e40c9f62321fdbfad2dfa26742a28b.svg";